import { useMsal } from "@azure/msal-react";
import { useEffect, useState, useRef } from "react";
import uuid from "react-uuid";
import moment from "moment";
import Dialog from "../../components/Dialog";
import ModalReportStyles from "../../styles/pages/Summaries/ModalReportStyles";
import ButtonStyles from "../../styles/components/ButtonStyles";
import TableStyles from "../../styles/components/TableStyles";
import ModalCallback from "../../model/ModalCallback";
import GenericUtils from "../../utils/GenericUtils";
import ReportService from "../../service/Docente/ReportService";
import { StyledFormCheck } from "../../styles/MainStyles";
import InputCalendarStyles from "../../styles/components/InputCalendarStyles";
import PaginationLocal from "../../components/PaginationLocal";
import {
    ActionTakenEnum,
    StatusWorkflowEnum,
    StatusActivityPlanEnum,
    AllowanceStatusEnum,
    StatusTachProcess,
} from "../../model/Enums/TypeReport";
import InputText from "../../components/InputText";
import { ReportItem } from "../../model/Report";

const { BtnPrimary, DefaultButtonLink, BtnOutlinePrimary } = ButtonStyles;

const {
    StyledModalTitle,
    StyledContainerBtns,
    StyledEditP,
    StyledSearchInput,
} = ModalReportStyles;

export interface IModalSelectData {
    open: boolean;
    onClose?: (callback?: ModalCallback) => void;
    data: string;
    arrItems: (items: any[]) => void;
    dateItem: (initialDate: string, finalDate: string) => void;
    verifyDate: boolean;
    editItems: boolean;
    editData?: any;
    typeData?: string;
    reportGrade?: boolean;
    studentActivity: boolean;
}

const ModalSelectData: React.FC<IModalSelectData> = ({
    open,
    onClose,
    data,
    arrItems,
    dateItem,
    verifyDate,
    editItems,
    editData,
    typeData,
    reportGrade,
    studentActivity,
}) => {
    const { instance } = useMsal();
    const [dataReport, setDataReport] = useState<ReportItem[]>([]);
    const [searchDataReport, setSearchDataReport] = useState<ReportItem[]>([]);
    const [filteredDataReport, setFilteredDataReport] = useState<ReportItem[]>(
        []
    );
    const [dialogTitle, setDialogTitle] = useState<string>("");
    const [typeReport, setTypeReport] = useState<string>("");
    const [searchText, setSearchText] = useState<string>("");
    const [period, setPeriod] = useState<any>(null);
    const periodRef = useRef<any>();
    const isFormValid = period && Boolean(period[0]) && Boolean(period[1]);

    const motivoAbono = "Motivo Abono";
    const statusWorkflow = "Status Workflow";

    function getTypeReportEnum<T extends Record<string, unknown>>(
        enumObject: T
    ): { name: T[keyof T]; codeId: string }[] {
        return Object.values(enumObject).map((status) => ({
            name: status as T[keyof T],
            codeId: uuid(),
        }));
    }

    const setDataReports = (value: ReportItem[]) => {
        setDataReport(value);
        setSearchDataReport(value);
    };

    const setTitleAndType = (title: string, type: string) => {
        setDialogTitle(title);
        setTypeReport(type);
    };

    // eslint-disable-next-line sonarjs/cognitive-complexity
    const fetchUrlData = async (): Promise<void> => {
        let response;
        let cleanData;
        let path;
        let param: string;
        let id: string;
        let register: string;
        setTypeReport("list");
        setDialogTitle(`Selecione a(s) ${data}(s)`);

        if (data === "Escola") {
            response = await ReportService.getResultCenterRoute(instance);
            path = response.data.centroResultados;
            param = "escola";
        }
        if (data === "Modalidade") {
            response = await ReportService.getModalityRoute(instance);
            path = response.data.itens;
            param = "descricao";
            id = "id";
        }
        if (data === "Atividade") {
            response = await ReportService.getActivityRoute(
                instance,
                studentActivity
            );
            path = response.data.itens;
            param = "descricao";
            id = "atividadeId";
        }
        if (data === "Campus") {
            setDialogTitle(`Selecione o(s) ${data}`);
            response = await ReportService.getResultCampus(instance);
            path = response.data.campi;
            param = "name";
            id = "id";
        }
        if (data === "Curso") {
            setDialogTitle(`Selecione o(s) ${data}(s)`);
            response = await ReportService.getResultCenterRoute(instance);
            path = response.data.centroResultados;
            param = "nome";
            id = "id";
        }
        if (data === "Professor") {
            setDialogTitle(`Selecione o(s) ${data}(es)`);
            response = await ReportService.getProfessorRoute(instance);
            if (response.status === 206) {
                path = response.data._result;
            }
            if (response.status === 200) {
                path = response.data;
            }
            param = "nome";
            id = "docenteID";
            register = "matriculaAdp";
        }
        if (data === "Usuário") {
            setDialogTitle(`Selecione o(s) ${data}(s)`);
            response = await ReportService.getUsersRoute(instance);
            path = response.data.items;
            param = "nome";
            id = "docenteId";
            register = "matricula";
        }
        if (data === "Coordenador") {
            setDialogTitle(`Selecione o(s) ${data}(es)`);
            response = await ReportService.getCoordinatorRoute(instance);
            path = response.data.docentes;
            param = "nome";
            id = "docenteId";
            register = "matriculaAdp";
        }
        if (data === "Status TACH") {
            setDialogTitle(`Selecione o Status TACH`);
            cleanData = getTypeReportEnum(StatusActivityPlanEnum);
        }
        if (data === motivoAbono) {
            setDialogTitle(`Selecione o ${data}`);
            response = await ReportService.getBonusRoute(instance);
            path = response.data;
            param = "motivo";
        }
        if (data === "Referência") {
            setTitleAndType(`Selecione a data ${data}`, "date");
        }
        if (data === "Status Abono") {
            setTitleAndType(`Selecione o ${data}`, "string");
            cleanData = getTypeReportEnum(AllowanceStatusEnum);
        }
        if (data === statusWorkflow) {
            setTitleAndType(`Selecione o ${data}`, "string");
            cleanData = getTypeReportEnum(StatusWorkflowEnum);
        }
        if (data === "Ação Realizada") {
            setTitleAndType(`Selecione a ${data}`, "string");
            cleanData = getTypeReportEnum(ActionTakenEnum);
        }
        if (data === "Status Processo TACH") {
            setTitleAndType(`Selecione o Status Processo TACH`, "string");
            cleanData = getTypeReportEnum(StatusTachProcess);
        }

        if (GenericUtils.isSuccessStatus(response)) {
            const uniqueNames = new Set<string>();
            cleanData = path.reduce((acc: ReportItem[], item: any) => {
                const name = item[param];
                const registration = item[register];
                if (!uniqueNames.has(name)) {
                    uniqueNames.add(name);
                    // eslint-disable-next-line no-param-reassign
                    acc = [
                        ...acc,
                        {
                            name,
                            codeId: item[id] || uuid(),
                            add: false,
                            registration,
                            checkAll: false,
                        },
                    ];
                }
                return acc;
            }, []);
            setFilteredDataReport(cleanData);
        }

        setDataReports(cleanData);
    };

    const fetchEditData = () => {
        if (typeData === "list" && editData) {
            setTypeReport("list");
            setDialogTitle(`Selecione os itens para edição:`);
            setDataReports(editData);
        }
        if (typeData === "date") {
            setTypeReport("date");
        }
        if (typeData === "string" && editData) {
            setTypeReport("string");
            setDialogTitle(`Selecione o ítem para edição:`);
            setDataReports(editData);
        }
    };

    useEffect(() => {
        if (editItems) {
            fetchEditData();
        } else {
            fetchUrlData();
        }
    }, []);

    const handleSelectedData = () => {
        arrItems(dataReport);
    };

    const handleCheck = (itemId: string) => {
        const updateItem = (item: ReportItem) => {
            if (item.codeId === itemId) {
                return {
                    ...item,
                    add: !item.add,
                    checkAll: false,
                };
            }
            if (typeReport === "string" && item.add) {
                return {
                    ...item,
                    add: false,
                    checkAll: false,
                };
            }
            return item;
        };

        const checkedItem = dataReport.map(updateItem);
        const checkedItemBase = searchDataReport.map(updateItem);

        setDataReport(checkedItem);
        setSearchDataReport(checkedItemBase);
    };

    const handleCheckAll = () => {
        const updatedDataReport = dataReport.map((item: ReportItem) => {
            return { ...item, add: true, checkAll: true };
        });
        arrItems(updatedDataReport);
    };

    const getFinalDate = (startDate: string) => {
        const [day, month, year] = startDate.split("/").map(Number);
        const newStartDate = new Date(year, month - 1, day);
        const endDate = new Date(
            newStartDate.getTime() + 6 * 24 * 60 * 60 * 1000
        );
        const newMonth = String(endDate.getMonth() + 1).padStart(2, "0");
        return `${endDate
            .getDate()
            .toString()
            .padStart(2, "0")}/${newMonth}/${endDate.getFullYear()}`;
    };

    const formatingDate = (date: any) => {
        return `${date.getDate().toString().padStart(2, "0")}/${(
            date.getMonth() + 1
        )
            .toString()
            .padStart(2, "0")}/${date.getFullYear()}`;
    };

    const momentDate = (date: any) => moment(date).format("DD/MM/YYYY");

    const handleDate = (date: any) => {
        const [startDate, endDate] = verifyDate
            ? [
                  momentDate(date),
                  reportGrade
                      ? getFinalDate(momentDate(date))
                      : momentDate(date),
              ]
            : [formatingDate(date[0]), formatingDate(date[1])];

        dateItem(startDate, endDate);
    };

    const renderSelectedDates = (oneDate: boolean, value: string[]) => {
        const textDate = oneDate ? "Data selecionada:" : "Datas selecionadas:";
        const dates = oneDate ? value[0] : `${value[0]} - ${value[1]}`;

        return (
            <div style={{ marginTop: 20 }}>
                <StyledEditP>{textDate}</StyledEditP>
                <StyledEditP>{dates}</StyledEditP>
            </div>
        );
    };

    const dateDataReport = (
        <div style={{ height: editItems ? 300 : 250 }}>
            <StyledModalTitle>Selecione a {data}:</StyledModalTitle>
            {editItems && renderSelectedDates(verifyDate, editData)}
            <InputCalendarStyles.StyledCalendar
                ref={periodRef}
                placeholder="Selecione o período"
                dateFormat="dd/mm/yy"
                locale="pt-BR"
                selectionMode={verifyDate ? "single" : "range"}
                showButtonBar
                readOnlyInput
                disabledDays={reportGrade ? [2, 3, 4, 5, 6, 0] : [7]}
                autoZIndex
                touchUI
                value={period}
                onChange={(e: any) => setPeriod(e.target?.value)}
                style={{ marginTop: 30 }}
            />
            <StyledContainerBtns style={{ margin: "40px 0" }}>
                <BtnPrimary
                    disabled={verifyDate ? !period : !isFormValid}
                    onClick={() => {
                        handleDate(period);
                        onClose?.();
                    }}
                >
                    {editItems ? "Editar" : "Ok"}
                </BtnPrimary>
            </StyledContainerBtns>
        </div>
    );

    useEffect(() => {
        const rangePeriod = period && period[0] && period[1];
        const singlePeriod = period && period[0];
        const isPeriodValid = verifyDate ? singlePeriod : rangePeriod;
        const isPeriodRefValid = periodRef && periodRef.current;

        if (isPeriodValid && isPeriodRefValid) {
            periodRef.current.hide();
        }
    }, [period, periodRef]);

    const textButton = () => {
        let text;
        if (editItems && typeReport === "list") {
            text = "Editar Itens";
        }
        if (editItems && typeReport === "string") {
            text = "Editar";
        }
        if (!editItems && typeReport === "list") {
            text = "Adicionar Selecionados";
        }
        if (!editItems && typeReport === "string") {
            text = "Selecione";
        }
        return text;
    };

    const hasNewColumn = () => {
        return (
            data === "Coordenador" || data === "Professor" || data === "Usuário"
        );
    };

    const handleFilterBySearch = (value: string) => {
        if (!value.length) return setSearchDataReport(dataReport);

        const filteredData = dataReport.filter((item) =>
            item.name.toUpperCase().includes(value.toUpperCase())
        );

        return setSearchDataReport(filteredData);
    };

    const handleSearchFilter = (event: any) => {
        const { value } = event.target;
        setSearchText(value);
        handleFilterBySearch(value);
    };

    const searchInput = () => {
        if (!(data === "Status Workflow" || data === "Ação Realizada"))
            return (
                <StyledSearchInput>
                    <InputText
                        value={searchText}
                        placeholder={`Pesquisar por ${data}`}
                        onChange={(e) => handleSearchFilter(e)}
                    />
                </StyledSearchInput>
            );
        return null;
    };

    const bodyOfTable = filteredDataReport.map((item: any) => {
        return (
            <tr key={uuid()}>
                <td>{item.name}</td>
                {(data === "Coordenador" ||
                    data === "Professor" ||
                    data === "Usuário") && <td>{item.registration}</td>}
                <td>
                    <StyledFormCheck
                        type="checkbox"
                        id={item.codeId}
                        checked={item.add}
                        onChange={() => {
                            handleCheck(item.codeId);
                        }}
                    />
                </td>
            </tr>
        );
    });

    const tableDataReport = (
        <>
            <StyledModalTitle>{dialogTitle}</StyledModalTitle>
            {searchInput()}
            <TableStyles.TablePrimary
                bordered
                striped
                responsive
                style={{ marginBottom: 0 }}
            >
                <thead>
                    <tr>
                        <th>{data}</th>
                        {hasNewColumn() && <th>Matrícula</th>}
                        <th>Adicionar</th>
                    </tr>
                </thead>
                <tbody>
                    {dataReport?.length === 0 ? (
                        <tr>
                            <td colSpan={hasNewColumn() ? 3 : 2}>
                                Informações indisponíveis.
                            </td>
                        </tr>
                    ) : (
                        bodyOfTable
                    )}
                </tbody>
            </TableStyles.TablePrimary>
            <PaginationLocal
                items={searchDataReport}
                itemsPage={10}
                onPaginate={(filteredData) =>
                    setFilteredDataReport(filteredData)
                }
                hidePagination={false}
            />
            <StyledContainerBtns style={{ marginTop: "30px", gap: "20px" }}>
                <BtnPrimary
                    onClick={() => {
                        handleSelectedData();
                        onClose?.();
                    }}
                >
                    {textButton()}
                </BtnPrimary>
                {typeReport === "list" && (
                    <BtnOutlinePrimary
                        onClick={() => {
                            handleCheckAll();
                            onClose?.();
                        }}
                    >
                        Adicionar Todos
                    </BtnOutlinePrimary>
                )}
                <DefaultButtonLink onClick={onClose}>
                    Cancelar
                </DefaultButtonLink>
            </StyledContainerBtns>
        </>
    );

    return (
        <Dialog openModal={open} onHide={onClose} size="600px">
            {typeReport === "string" && tableDataReport}
            {typeReport === "list" && tableDataReport}
            {typeReport === "date" && dateDataReport}
        </Dialog>
    );
};

export default ModalSelectData;
